import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ApiEndpoints } from '@core/constants';

@Injectable({
  providedIn: 'root'
})
export class SecondaryOrgsService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }
  getSecondaryOrgById(params): Observable<any> {
    return this.http.post<any>(ApiEndpoints.secondaryOrgApi, params)
      .pipe(
        catchError(this.handleError<any>('getSecondaryOrgById', []))
      );
  }
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      return of(result as T);
    };
  }
}